import { publicSiteTheme } from './publicSiteTheme.js';
import { secureSiteTheme } from './secureSiteTheme.js';
import { defaultTheme } from './defaultTheme.js';

//TODO: release a breaking change to deprecate or cleanup these names
var themes = {
  "default": secureSiteTheme,
  lincoln: secureSiteTheme,
  publicSite: publicSiteTheme,
  secureSite: secureSiteTheme,
  legacy: defaultTheme
};

export default themes;
